import { type LinksFunction, Outlet } from "react-router";

import { LogoWithTitle } from "@/site/ui/logo-with-title";

import { SidePattern } from "./ui/side-pattern";
import styleSheet from "./ui/tailwind.css?url";

export const links: LinksFunction = () => [
  { rel: "stylesheet", href: styleSheet as string },
];

export default function AuthLayout() {
  return (
    <div className="grid min-h-dvh items-center lg:grid-cols-[1fr_31rem_1fr]">
      <SidePattern />

      <div className="anecdote-auth-card bg-card mx-5 rounded-3xl border px-8 py-10 lg:mx-0">
        <LogoWithTitle className="mb-8 justify-center" linkTo="/" />
        <div className="mx-auto w-full max-w-sm">
          <Outlet />
        </div>
      </div>

      <SidePattern isReversed />
    </div>
  );
}
